import { render, staticRenderFns } from "./BtnPreviousStep.vue?vue&type=template&id=64d310b8"
import script from "./BtnPreviousStep.vue?vue&type=script&lang=js"
export * from "./BtnPreviousStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports